import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEdit, FiTrash2, FiChevronUp, FiChevronDown } from 'react-icons/fi';
import axios from 'axios';
import { FaFileExcel } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { User } from 'react-feather'; // Import the User icon
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';



// Styled components
const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 3px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#293495;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;
const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // margin:14px 44px;
`;
const ProfileIcon = styled.div`
 width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  box-shadow: 0px 10px 20px #0000001A;
  border-radius: 6px;
  opacity: 1;
`;

const TableHeader = styled.thead`
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  color: #000;
`;

const TableRow = styled.tr``;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  position: relative; /* Use relative positioning */
  cursor: pointer; /* Show that it's clickable */
  &:hover {
    color: #293495; /* Change color on hover */
  }

  /* Apply padding-right to make space for the sort icon */
  padding-right: 25px; 
`;

const SortIconContainer = styled.span`
  position: absolute;
  top: 57%;
  transform: translateY(-50%); /* Vertically center the icon */
  svg {
    font-size: 16px; /* Adjust the size of the icon */
    color: #000; /* Set the icon color */
  }
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
`;

// Pagination Styled Components

// Pagination Styled Components
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;
const StyledDatePicker = styled(DatePicker)`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: 'Segoe UI', Regular;
    background: transparent;
    border-bottom: 1px solid #2B3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2B3497;
    }
  }`

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2b3497;
  margin: 0 5px;
`;
const DateContainer = styled.div`
display: flex;
align-items: flex-end;
gap: 20px;
margin-left: 20px;

`;

const DateInputContainer = styled.div`
display: flex;
flex-direction: column;
gap: 5px;

`;

const Label = styled.label`
color: #3D46B4;
margin-bottom: 5px;
`;
const Card = styled.div`
  box-shadow: 0px 5px 10px #00000038;
  background: #fff;
  border-radius: 10px;
  opacity: 1;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const Dropdown = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
border-bottom: 2px solid #3D46B4;
padding: 10px;
border-radius: 4px;
background: white;
cursor: pointer;
position: relative;
background: transparent;
`;

const DropdownText = styled.span`
color: #293495;
font-size: 16px;
`;

const DropdownIcon = styled(FiChevronDown)`
color: #3D46B4;
`;

const DropdownPanel = styled.div`
position: absolute;
top: calc(100% + 5px); /* Positioning panel just below the dropdown */
left: 0;
width: 100%;
background: white;
border: 1px solid #3D46B4;
border-radius: 4px;
box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
z-index: 1;
`;

const DropdownOption = styled.div`
padding: 10px;
cursor: pointer;
&:hover {
  background-color: #f0f0f0;
}
`;

const ButtonGroup = styled.div`
display: flex;
gap: 10px;
@media (max-width: 768px) {
  justify-content: center;
  margin-top: 20px;
}
`;

const Button = styled.button`
padding: 10px 20px;
border: none;
border-radius: 12px;
font-size: 16px;
color: #fff;
cursor: pointer;
box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
&:first-child {
  background-color: #FF4B4B;
  box-shadow: 0px 10px 20px #7E18182E;
}
&:last-child {
  background-color: #2B3497;
  box-shadow: 0px 10px 20px #2B349752;
}
`;


const CardIssuranceReportPage = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [visitorData, setVisitorData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);
    const rowsPerPage = 7;

    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });


    const renderSortIcon = (key) => {
        if (sortConfig.key === key) {
            return (
                <SortIconContainer>
                    {sortConfig.direction === 'ascending' ? <FiChevronUp style={{ fontSize: '18px', fontWeight: 'bold', color: '#000' }} /> : <FiChevronDown style={{ fontSize: '18px', fontWeight: 'bold', color: '#000' }} />}
                </SortIconContainer>
            );
        }
        return (
            <SortIconContainer>
                <FiChevronDown style={{ opacity: 0.3 }} /> {/* Default icon */}
            </SortIconContainer>
        );
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
        const sortedData = [...visitorData].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
            return 0;
        });
        setVisitorData(sortedData);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchVisitorTypeData();
    }, []);

    // useEffect(() => {
    //     setFilteredData(
    //         visitorData.filter((visitor) =>
    //                  visitor.checkInId?.toString().includes(searchTerm) ||
    //                 visitor.visitorName?.toLowerCase().includes(searchTerm) ||
    //                 visitor.visitorCompany?.toLowerCase().includes(searchTerm) ||
    //                 visitor.checkinType?.toLowerCase().includes(searchTerm) ||
    //                 visitor.isBlacklisted?.toString().includes(searchTerm) 
    //         )
    //     );
    // }, [searchTerm, visitorData]);

    const fetchVisitorTypeData = async () => {
        try {
            const response = await axios.get('/Report/GetCardIssuanceReport');
            setVisitorData(response.data);
        } catch (error) {
            console.error('Error fetching Visitor Report data:', error);
        }
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };
    const filteredData = visitorData.filter((visitor) => {
        return (
            visitor.checkInId?.toString().includes(searchTerm) ||
            visitor.visitorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visitor.visitorIdNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visitor.nationality?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visitor.checkInDateTime?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (visitor.cardNumber?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ?? false)
        );
    });
    useEffect(() => {
          setCurrentPage(1);
        }, [searchTerm]);

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    const handlePageChange = (event) => {
        setCurrentPage(Number(event.target.value));
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };



    const currentRows = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    const renderPageNumbers = () => {
        const pageNumbers = [];
        const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

        let startPage = Math.max(currentPage - 5, 1);
        let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

        // Adjust startPage if endPage exceeds totalPages
        if (endPage === totalPages) {
            startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <PaginationButton
                    key={i}
                    className={currentPage === i ? 'active' : ''}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </PaginationButton>
            );
        }

        return pageNumbers;
    };
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    // Function to toggle the export options panel
    const togglePanel = () => {
        setIsPanelOpen((prevState) => !prevState);
    };

    const handleExportOptionClick = (format) => {
        if (format === 'excel') {
            exportToExcel(); // Call the Excel export function
        } else if (format === 'pdf') {
            exportToPDF(); // Call the PDF export function
        }

        // Close the panel after making a selection
        setIsPanelOpen(false);
    };
    const exportToExcel = () => {


        const filteredDataNee = filteredData.map((row) => ({
            cardNumber: row.cardNumber,
            visitorName: row.visitorName,
            visitorId: row.visitorIdNumber,
            visitorMobile: row.visitorMobile,
            Natioality: row.nationality,
            visiId: row.checkInId,
            ChekIn: row.checkInDateTime,
            CheckOut: row.checkOutTime === "0001-01-01T00:00:00" || row.checkOutTime === null ? " " : row.checkOutTime,
        }));

        // Create the worksheet with the filtered data
        const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Card Issuance Report');

        // Adjust column widths for better alignment (optional)
        worksheet['!cols'] = [
            { wpx: 100 }, // appointmentId
            { wpx: 150 }, // source
            { wpx: 150 }, // visitorName
            { wpx: 150 }, // visitorName
            { wpx: 150 }, // visitorName
            { wpx: 150 }, // visitorTypeDesc
            { wpx: 150 }, // visitorMobile
            { wpx: 150 }, // host

        ];


        XLSX.writeFile(workbook, 'Card_issuance_Report.xlsx');
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        doc.text('Card Issuance Reports', 14, 16);
        doc.autoTable({
            head: [
                ['Photo','Card Number', 'Visitor Name', 'Visitor Id','Visitor Mobile','Nationality', 'Visit ID', 'Check-In', 'Check-Out']
            ],
            body: filteredData.map((row) => [
                '',
                row.cardNumber,
                row.visitorName,
                row.visitorIdNumber,
                row.visitorMobile,
                row.nationality,
                row.checkInId,
                row.checkInDateTime,
                row.checkOutTime === "0001-01-01T00:00:00" || row.checkOutTime === null ? " " : row.checkOutTime,
            ]),
            startY: 30,
            theme: 'grid',
            didDrawCell: (data) => {
                // Ensure we only process body cells, not header or footers
                if (data.section === 'body' && data.column.index === 0 && filteredData[data.row.index]?.visitorPhoto) {
                    const img = `data:image/png;base64,${filteredData[data.row.index].visitorPhoto}`;
                    
                    // Get cell dimensions
                    const cellWidth = data.cell.width;
                    const cellHeight = data.cell.height;
    
                    // Define the image size (smaller to fit properly)
                    const imgSize = Math.min(cellWidth, cellHeight) - 2; // Padding of 2px on each side
    
                    // Center the image within the cell
                    const xOffset = data.cell.x + (cellWidth - imgSize) / 2;
                    const yOffset = data.cell.y + (cellHeight - imgSize) / 2;
    
                    doc.addImage(img, 'PNG', xOffset, yOffset, imgSize, imgSize);
                }
            },
        });
        doc.save('Card_issuance_Report.pdf');
    };
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);


    const handleSearchData = async () => {
        const formatDate = (date) => {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        // Format dates only if they are selected
        const formattedFromDate = fromDate ? formatDate(fromDate) : '';
        const formattedToDate = toDate ? formatDate(toDate) : '';

        console.log("fromdate:", formattedFromDate || "empty");
        console.log("toDate:", formattedToDate || "empty");

        try {
            // Pass empty parameters if dates are not selected
            const response = await axios.get(`/Report/GetCardIssuanceReport?fromDate=${formattedFromDate}&toDate=${formattedToDate}`);
            setVisitorData(response.data);
        } catch (error) {
            console.error('Error fetching Visitor Report data:', error);
        }
    };

    const handleReset = async () => {
        setFromDate(null);
        setToDate(null);
        try {
            const response = await axios.get('/Report/GetCardIssuanceReport');
            setVisitorData(response.data);
        } catch (error) {
            console.error('Error fetching Visitor Report data:', error);
        }
    }




    return (
        <Container>
            <Header>
                <Heading>Card Issuance Report</Heading>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SearchBox>
                        <SearchIcon size={20} />
                        <SearchInput
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </SearchBox>
                    <DropdownContainerTwo>
                        <ExportIcon onClick={togglePanel} title="Export">
                            <FiDownload size={25} />
                        </ExportIcon>
                        {/* Show the panel with options if isPanelOpen is true */}
                        {isPanelOpen && (
                            <OptionsPanel>
                                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
                            </OptionsPanel>
                        )}
                    </DropdownContainerTwo>
                </div>
            </Header>
            <Card>
                <DateContainer>
                    <DateInputContainer>
                        <Label>From Date</Label>
                        <StyledDatePicker
                            selected={fromDate}
                            onChange={(date) => setFromDate(date)}
                            dateFormat="dd-MM-yyyy"
                        />
                    </DateInputContainer>
                    <DateInputContainer>
                        <Label>To Date</Label>
                        <StyledDatePicker
                            selected={toDate}
                            onChange={(date) => setToDate(date)}
                            dateFormat="dd-MM-yyyy"
                            minDate={fromDate}
                            maxDate={new Date()}
                        />
                    </DateInputContainer>
                </DateContainer>
                <ButtonGroup>

                    <Button onClick={handleReset}>Reset</Button>
                    <Button onClick={handleSearchData}>Search</Button>
                </ButtonGroup>
            </Card>
            <TableContainer>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell colSpan={'9'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Card Issuance Report</span>
                                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                                    </IconWrapper>
                                </div>
                            </TableHeaderCell>

                        </TableRow>
                    </TableHeader>
                    {isExpanded && (
                        <>
                            <TableHeader>
                                <TableRow>
                                    <TableHeaderCell>Photo</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('cardNumber')}>Card Number {renderSortIcon('cardNumber')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('visitorName')}>Visitor Name {renderSortIcon('visitorName')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('visitorIdNumber')}>Visitor ID {renderSortIcon('visitorIdNumber')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('visitorMobile')}>Visitor Mobile {renderSortIcon('visitorMobile')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('nationality')}>Nationality {renderSortIcon('nationality')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('checkInId')}>Visit ID{renderSortIcon('checkInId')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('checkInDateTime')}>Check-In {renderSortIcon('checkInDateTime')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('checkOutTime')}>Check-Out {renderSortIcon('checkOutTime')}</TableHeaderCell>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {currentRows.map((visitor, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Circle> {visitor.visitorPhoto ? (
                                                <img
                                                    src={`data:image/png;base64,${visitor.visitorPhoto}`}
                                                    alt="Profile"
                                                    style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                                                />
                                            ) : (
                                                <ProfileIcon>
                                                    <User size={15} />
                                                </ProfileIcon>
                                            )}
                                            </Circle>
                                        </TableCell>
                                        <TableCell>{visitor.cardNumber}</TableCell>
                                        <TableCell>{visitor.visitorName}</TableCell>
                                        <TableCell>{visitor.visitorIdNumber}</TableCell>
                                        <TableCell>{visitor.visitorMobile}</TableCell>
                                        <TableCell>{visitor.nationality}</TableCell>
                                        <TableCell>{visitor.checkInId}</TableCell>
                                        <TableCell>
                                            {new Intl.DateTimeFormat('en-CA', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false
                                            }).format(new Date(visitor.checkInDateTime))
                                                .replace(',', ' :')}
                                        </TableCell>
                                        <TableCell>
                                            {visitor.checkOutTime === "0001-01-01T00:00:00" || visitor.checkOutTime === null
                                                ? " "
                                                : new Intl.DateTimeFormat('en-CA', {
                                                    year: 'numeric',
                                                    month: '2-digit',
                                                    day: '2-digit',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: false
                                                }).format(new Date(visitor.checkOutTime))
                                                    .replace(',', ' :')}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </>)}
                </Table>
            </TableContainer>
            {isExpanded && (
                <>
                    <PaginationContainer>
                        <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                            Previous
                        </PaginationButton>

                        <DropdownSelect value={currentPage} onChange={handlePageChange}>
                            {Array.from({ length: totalPages }, (_, i) => (
                                <option key={i + 1} value={i + 1}>
                                    Page {i + 1}
                                </option>
                            ))}
                        </DropdownSelect>

                        <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                            Next
                        </PaginationButton>
                    </PaginationContainer>
                </>)}
        </Container>
    );
};

export default CardIssuranceReportPage;
